<template>
  <div class="feed-footer">
    <div class="feed-handle">
      <ul class="hl_row_line flex">
        <li>
          <span class="handle-text">浏览</span>
          <span class="handle-count">{{ viewCount }}</span>
        </li>
        <li>
          <a href="javascript:;" @click="switchComment">
            <span class="handle-icon comment"></span>
            <span class="handle-count">{{ commentCount }}</span>
          </a>
        </li>
        <li>
          <a href="javascript:;" @click="praiseFeed">
            <span class="handle-icon" :class="praiseStatus"></span>
            <span class="handle-count">{{ praiseCount }}</span>
          </a>
        </li>
        <li>
          <a class="storage-wrap" href="javascript:;">
            <span :class="isStoraged" @click="initSaveForever">永久保存</span>
          </a>
        </li>
      </ul>
      <span class="triangle" v-if="unfoldComment"></span>
    </div>
    <div class="feed-comment" v-if="unfoldComment">
      <div class="comment-list" v-loading="commentShade">
        <CommentItem
          v-for="(comment, index) in commentList"
          :key="index"
          :comment="comment"
          :replyList="comment.replyData"
          :replyCount="comment.replyData.length"
          :deleteStatus="comment.isDeleted"
          :showStatus="comment.isShow"
          @handleDelete="deleteComment"
          @handleReload="reloadCommentList"
        />
        <p class="no-comment" v-if="commentList.length == 0">
          {{ noCommentText }}
        </p>
        <div class="pagination-wrapper">
          <el-pagination
            layout="prev, pager, next"
            :total="totalPage"
            prev-text="上一页"
            next-text="下一页"
            hide-on-single-page
            @current-change="curCommentPageClick"
          ></el-pagination>
          <!-- @prev-click="prevCommentPageClick" @next-click="nextCommentPageClick" -->
        </div>
      </div>
      <div class="comment-box">
        <div class="input-wrapper">
          <el-input
            type="textarea"
            resize="none"
            maxlength="100"
            show-word-limit
            :autosize="{ minRows: 2 }"
            placeholder="评论..."
            v-model="commentContent"
          ></el-input>
        </div>
        <div class="comment-btn flex">
          <span></span>
          <el-button
            class="send-comment"
            :disabled="forbidComment"
            @click="submitComment"
            >发表</el-button
          >
        </div>
      </div>
    </div>
    <div class="save-feed-wrap">
      <el-dialog
        title="确定永久保存吗?"
        :visible.sync="saveVisible"
        width="500px"
        custom-class="handlian-share-article"
      >
        <div class="space-progress-wrap">
          <p class="forever-save-tip">{{ everStorageRate.title }}</p>
          <p class="space-explain">
            永久存储空间使用情况
            <span class="space-index">{{ everStorageRate.text }}</span>
          </p>
          <el-progress
            :percentage="everStorageRate.percentage"
            :text-inside="true"
            :stroke-width="15"
            :color="spaceRateColor"
          ></el-progress>
        </div>
        <div class="save-btn-bar">
          <el-button class="handlian-btn" @click="saveVisible = false"
            >取 消</el-button
          >
          <el-button
            class="handlian-btn"
            type="primary"
            @click="modifyFeedSaveStatus()"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { tranNumber } from "../../../utils/feed";
import { apiMap } from "../../../utils/apiMap";
import CommentItem from "../../friend/comment-item";
let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
export default {
  name: "feed-footer",
  props: {
    feed: {
      type: Object,
      required: true,
    },
    feedType: {
      type: String,
      required: true,
    },
  },
  data() {
    var storageState = "not-storage";
    if (this.feed.isStoraged == 1) {
      storageState = "is-storaged";
    }
    return {
      unfoldComment: false,
      praised: false,
      dissed: false,
      commentShade: true,
      commentList: [],
      commentTotal: 0,
      curCommentPage: 1,
      forbidComment: true,
      commentContent: "",
      noCommentText: "",
      isStoraged: storageState,
      saveVisible: false,
      everStorageRate: {
        percentage: 0,
        text: "",
        title: "",
      },
      spaceRateColor: "#3C9FAB",
    };
  },
  components: {
    CommentItem,
  },
  computed: {
    ...mapGetters(["userProfile"]),
    viewCount() {
      return tranNumber(this.feed.readCount);
    },
    commentCount() {
      return tranNumber(this.feed.commentCount);
    },
    praiseCount() {
      return tranNumber(this.feed.upCount);
    },
    dissCount() {
      return tranNumber(this.feed.downCount);
    },
    praiseStatus() {
      if (this.praised == true) {
        return "praised";
      } else {
        return "unpraise";
      }
    },
    dissStatus() {
      if (this.dissed == true) {
        return "dissed";
      } else {
        return "undiss";
      }
    },
    totalPage() {
      return this.commentTotal;
    },
    initIsStoraged() {
      if (this.feed.isStoraged == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    switchComment() {
      // console.log(this.feed)
      if (this.unfoldComment == false) {
        this.unfoldComment = true;
        this.getCommentList(1);
      } else {
        this.unfoldComment = false;
        (this.commentList = []), (this.commentShade = true);
      }
    },
    getCommentList(start) {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["commentsList"]["method"],
          url: apiMap["commentsList"]["url"],
          data: `token=${loginUser.token}&modelType=${_this.feedType}&modelId=${_this.feed.id}&start=${start}&count=10`,
        })
        .then(function (response) {
          _this.commentShade = false;
          if (response.data.result.statusCode == 1) {
            _this.commentTotal = response.data.result.count;
            _this.feed.commentCount = response.data.result.count;
            _this.commentList = response.data.result.data;
          } else {
            _this.noCommentText = "暂无评论";
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    praiseFeed() {
      // var originPraise = this.feed.upCount;
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["praiseFeed"]["method"],
          url: apiMap["praiseFeed"]["url"],
          data: `token=${loginUser.token}&modelType=${_this.feedType}&modelId=${_this.feed.id}&praiseType=1`,
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            if (_this.praised == true) {
              _this.feed.upCount -= 1;
              _this.praised = false;
            } else {
              _this.praised = true;
              _this.feed.upCount += 1;
            }
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    initSaveForever() {
      // if (this.isStoraged == 'not-storage') {
      //     this.isStoraged = 'is-storaged'
      // } else {
      //     this.isStoraged = 'not-storage'
      // }
      if (this.feed.isStoraged == 1) {
        var confirmText = `确定不再永久保存《 ${this.feed.title} 》吗？`;
        this.$confirm(confirmText, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info",
          closeOnClickModal: false,
        })
          .then(() => {
            this.modifyFeedSaveStatus();
          })
          .catch(() => {});
      } else {
        var usedForeverSpace = parseFloat(
          this.userProfile.usedForeverSpaceMbNum
        );
        var totalForeverSpace = parseFloat(
          this.userProfile.totalForeverSpaceMbNum
        );
        var residueForeverRate = (
          (usedForeverSpace / totalForeverSpace) *
          100
        ).toFixed(2); //百分比
        if (isNaN(residueForeverRate)) {
          residueForeverRate = 0;
        }
        if (residueForeverRate < 1) {
          this.$alert("您的永久存储空间不足，请在手机端购买", {
            confirmButtonText: "确定",
            showClose: false,
          });
        } else {
          var production = `即将永久保存：《 ${this.feed.title} 》`;
          if (this.feedType) {
            switch (this.feedType) {
              case "1":
                production = `即将永久保存文章：《 ${this.feed.title} 》`;
                break;
              case "2":
                production = `即将永久保存相册：《 ${this.feed.title} 》`;
                break;
              case "3":
                production = `即将永久保存音频：《 ${this.feed.title} 》`;
                break;
              case "4":
                production = `即将永久保存视频：《 ${this.feed.title} 》`;
                break;
            }
          }
          this.everStorageRate.percentage = residueForeverRate * 1;
          this.everStorageRate.text =
            " （ " + usedForeverSpace + " M / " + totalForeverSpace + " M ）";
          this.everStorageRate.title = production;
          this.saveVisible = true;
        }
      }
    },
    modifyFeedSaveStatus() {
      var queryUrl = "";
      var queryMehod = "";
      var queryParams = "";
      let _this = this;
      switch (_this.feedType) {
        case "1":
          queryMehod = apiMap["saveArticle"]["method"];
          queryUrl = apiMap["saveArticle"]["url"];
          queryParams = `token=${loginUser.token}&articleId=${_this.feed.id}`;
          break;
        case "2":
          queryMehod = apiMap["saveAlbum"]["method"];
          queryUrl = apiMap["saveAlbum"]["url"];
          queryParams = `token=${loginUser.token}&photoId=${_this.feed.id}`;
          break;
        case "3":
          queryMehod = apiMap["saveMusic"]["method"];
          queryUrl = apiMap["saveMusic"]["url"];
          queryParams = `token=${loginUser.token}&musicId=${_this.feed.id}`;
          break;
        case "4":
          queryMehod = apiMap["saveVideo"]["method"];
          queryUrl = apiMap["saveVideo"]["url"];
          queryParams = `token=${loginUser.token}&videoId=${_this.feed.id}`;
          break;
      }

      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: queryMehod,
          url: queryUrl,
          data: queryParams,
          timeout: 5000,
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            _this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              offset: 230,
            });
            _this.saveVisible = true;
            _this.emitReloadList();
            _this.$bus.$emit("update-user-profile");
            _this
              .$axios({
                baseURL: apiMap["commonUrl"],
                method: apiMap["hiddenProduction"]["method"],
                url: apiMap["hiddenProduction"]["url"],
                data: `token=${loginUser.token}&modelId=${_this.feed.id}&modelType=${_this.feedType}&hidden=2`,
              })
              .then(function (response) {
                if (response.data.result.statusCode == 1) {
                  _this.emitReloadList();
                } else {
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
          if (error.message.includes("timeout")) {
            _this.$alert("请求服务器超时", {
              confirmButtonText: "确定",
              showClose: false,
            });
          } else {
          }
        });
    },
    deleteComment(commentID) {
      var findIndex = -1;
      this.commentList.filter((item, index) => {
        if (item.id == commentID) {
          findIndex = index;
        }
      });
      if (findIndex != -1) {
        this.commentList.splice(findIndex, 1);
        this.feed.commentCount -= 1;
      }
    },
    submitComment() {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["publishComment"]["method"],
          url: apiMap["publishComment"]["url"],
          data: `token=${loginUser.token}&modelType=${_this.feedType}&modelId=${_this.feed.id}&content=${_this.commentContent}`,
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            var myComment = {
              content: _this.commentContent,
              created_at: Math.round(new Date() / 1000),
              id: response.data.result.data.commentId,
              isDeleted: 0,
              isShow: 1,
              modelId: _this.feed.id,
              modelType: _this.feedType,
              ownerUserId: _this.feed.userId,
              praise: 0,
              praiseStatus: 0,
              replyCount: 0,
              replyData: Array(0),
              updated_at: null,
              userId: loginUser.userId,
              userInfo: {
                headImgUrl: loginUser.headImgUrl,
                name: loginUser.nickName,
                realName: "",
                thumbHeadImg: loginUser.thumbHeadImg,
              },
              userInfoExtend: loginUser.nickName,
            };
            _this.commentList.push(myComment);
            _this.commentContent = "";
            _this.feed.commentCount += 1;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    prevCommentPageClick(newPage) {
      //即将加载的起始页
      this.commentShade = true;
      this.curCommentPage = newPage;
      this.getCommentList(newPage);
    },
    curCommentPageClick(newPage) {
      //即将加载的起始页
      this.commentShade = true;
      this.curCommentPage = newPage;
      this.getCommentList(newPage);
    },
    nextCommentPageClick(newPage) {
      this.commentShade = true;
      this.curCommentPage = newPage;
      this.getCommentList(newPage);
    },
    reloadCommentList() {
      this.getCommentList(this.curCommentPage);
    },
    emitReloadList() {
      switch (this.feedType) {
        case "1":
          this.$bus.$emit("reload-article-list");
          break;
        case "2":
          this.$bus.$emit("reload-album-list");
          break;
        case "3":
          this.$bus.$emit("reload-audio-list");
          break;
        case "4":
          this.$bus.$emit("reload-video-list");
          break;
      }
    },
  },
  watch: {
    commentContent(text) {
      if (text === "" || text.trim().length === 0) {
        this.forbidComment = true;
      } else {
        this.forbidComment = false;
      }
    },
  },
};
</script>
<style scoped>
.feed-handle {
  position: relative;
}

.hl_row_line {
  justify-content: space-between;
}

.hl_row_line li {
  width: 25%;
  height: 25px;
  line-height: 25px;
}

.handle-text {
  color: #999999;
}

.hl_row_line li:last-child {
  width: 85px;
}

.handle-icon {
  position: relative;
  top: 3px;
  display: inline-block;
  width: 19px;
  height: 17px;
  background-repeat: no-repeat;
  background-size: contain;
}

.handle-count {
  margin-left: 5px;
  color: #e74f52;
}

.feed-handle .triangle {
  position: absolute;
  top: 17px;
  left: 241px;
  height: 0;
  width: 0;
  content: "";
  z-index: 1;
  border: 8px solid rgba(0, 0, 0, 0);
  border-bottom-color: #ebebeb;
}

.comment {
  background-image: url("../../../assets/icon/cl_feed_comment.png");
}

.unpraise {
  background-image: url("../../../assets/icon/cl_feed_praise.png");
}

.praised {
  background-image: url("../../../assets/icon/cl_feed_praised.png");
}

.storage-wrap span {
  display: inline-block;
  padding-left: 25px;
  background-repeat: no-repeat;
}

.storage-wrap span:hover {
  color: #1a70db;
}

.not-storage {
  color: #000;
  background-image: url("../../../assets/icon/user/cl_unchecked.png");
  background-position: 2px 3px;
}

.is-storaged {
  color: #000;
  background-image: url("../../../assets/icon/user/cl_checked.png");
  background-position: 2px 3px;
}

.feed-comment {
  border: 1px solid #ebebeb;
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
  background: #fff;
  margin-top: 7px;
  overflow: visible;
  border-radius: 4px;
}

.comment-list {
  min-height: 50px;
}

.comment-box {
  padding: 6px 10px;
  border-top: 1px solid #ebebeb;
}

.comment-btn {
  justify-content: space-between;
}

.send-comment {
  padding: 4px 10px;
}

.input-wrapper {
  margin-bottom: 4px;
}

.pagination-wrapper {
  text-align: center;
}

.no-comment {
  line-height: 50px;
  text-align: center;
  color: #999;
}

.space-index {
  font-weight: bold;
}

.space-progress-wrap {
  line-height: 30px;
}

.save-btn-bar {
  margin-top: 10px;
  text-align: right;
}
</style>